/**
 * Persistencia de tokens en localStorage.
 *
 * Nota: localStorage es vulnerable a XSS. Para el MVP es aceptable.
 * Cuando endurezcamos seguridad: refresh_token a httpOnly cookie y
 * access_token solo en memoria.
 */

const STORAGE_KEY = "ep_tokens_v1";
/**
 * El portal del paciente guarda su sesión aparte.
 *
 * En el mostrador conviven las dos: la recepcionista tiene su sesión abierta y
 * a la vez enseña el portal a un paciente. Con una sola clave, entrar en uno
 * echaba al otro.
 */
const STORAGE_KEY_PORTAL = "ep_portal_tokens_v1";

export interface StoredTokens {
  access_token: string;
  refresh_token: string;
  access_expires_at: string;
  refresh_expires_at: string;
}

export function getTokens(): StoredTokens | null {
  const raw = localStorage.getItem(STORAGE_KEY);
  if (!raw) return null;
  try {
    return JSON.parse(raw) as StoredTokens;
  } catch {
    return null;
  }
}

export function setTokens(tokens: StoredTokens): void {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(tokens));
}

export function clearTokens(): void {
  localStorage.removeItem(STORAGE_KEY);
}


// ---------- Portal del paciente ----------

export function getPortalTokens(): StoredTokens | null {
  const raw = localStorage.getItem(STORAGE_KEY_PORTAL);
  if (!raw) return null;
  try {
    return JSON.parse(raw) as StoredTokens;
  } catch {
    return null;
  }
}

export function setPortalTokens(tokens: StoredTokens): void {
  localStorage.setItem(STORAGE_KEY_PORTAL, JSON.stringify(tokens));
}

export function clearPortalTokens(): void {
  localStorage.removeItem(STORAGE_KEY_PORTAL);
}
